// extracted by mini-css-extract-plugin
export default {"rounded-image":"RoundedImage_rounded-image__YQ6tO","rounded-image-container":"RoundedImage_rounded-image-container__VVWJo"};